export default __webpack_public_path__ + "images/08daacf2a69e90ae146d783b36fccdad-Daybreaker_web_1919x543.jpg";